import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import VeeValidate from 'vee-validate';
import VueMask from 'vue-the-mask';
import Croppa from 'vue-croppa';
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
import VueAnalytics from 'vue-analytics';
import App from './App';
import router from './router';
import store from './stores';
import i18n from './i18n';
import phoneNumberValidation from './validations/phoneNumber';
import postalCodeValidation from './validations/postalCode';
import timeValidation from './validations/time';
import config from '@/config';

import './registerServiceWorker';

VeeValidate.Validator.extend('phoneNumber', phoneNumberValidation);
VeeValidate.Validator.extend('postalCode', postalCodeValidation);
VeeValidate.Validator.extend('time', timeValidation);

Vue.use(VueMask);
Vue.use(VeeValidate);
Vue.use(BootstrapVue);
Vue.use(Croppa);

if (config.ENV.ID !== 'DEV' && config.GA_ID) {
  Vue.use(VueAnalytics, {
    id: config.GA_ID,
    router,
    debug: {
      enable: config.ENV.ID !== 'PROD',
      sendHitTask: true,
    },
  });
}

if (config.ENV.ID !== 'DEV' && config.SENTRY_IO) {
  Sentry.init({
    dsn: config.SENTRY_IO,
    integrations: [new Integrations.Vue({ Vue })],
    environment: config.ENV.ID,
  });
}

Vue.config.productionTip = false;
if (config.ENV.DEBUG) {
  Vue.config.devtools = true;
}

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app');

require('@fortawesome/fontawesome-pro/css/all.css');
